<template>
  <v-card class="mb-16">
    <v-row class="justify-center">
      <v-col cols="11">
        <v-card>
          <v-card-title class="justify-space-around text-center">
            <v-row class="justify-center">
              <v-col cols="12">
                <h3 class="text-h2">
                  {{ $t('L_confirm_your_payment_option') }}
                </h3>
                <div
                  class="mt-3 text-h4 font-weight-regular text-wrap text-left"
                  v-html="$t('L_primerica_life_will_immediately', { date: getWithDrawDate })"
                ></div>
              </v-col>
            </v-row>
          </v-card-title>
          <!-- This is for mobile screen only -->
          <v-card-text
            v-if="$vuetify.display.xs"
            class="justify-center background-light-grey pl-4 textCenter"
          >
            <v-row mb-4 pt-2>
              <v-col cols="12">
                <div class="mb-2">
                  <span class="font-weight-medium">{{ $t('L_premium_amount') }}</span>
                </div>
                <div>
                  <span class="font-weight-regular grey-ada-text"> {{ initialPremium }}</span>
                </div>
              </v-col>
            </v-row>
            <!-- Row Two -->
            <v-row class="mb-4 pt-2">
              <v-col cols="12">
                <div class="mb-2">
                  <span class="font-weight-medium">{{ $t('L_account_number') }}</span>
                </div>
                <div>
                  <span class="font-weight-regular grey-ada-text"
                    >{{ hideNums(selpackage.pacAcctNum) }}
                  </span>
                </div>
              </v-col>
            </v-row>
            <!-- Row Three -->
            <v-row class="mb-4">
              <v-col cols="12">
                <div class="mb-2">
                  <span class="font-weight-medium">{{ $t('L_routing_number') }}</span>
                </div>
                <div>
                  <span class="font-weight-regular grey-ada-text">{{
                    hideNums(selpackage.pacBankNum)
                  }}</span>
                </div>
              </v-col>
            </v-row>

            <v-row class="mb-4 pt-2">
              <v-col cols="12">
                <div class="mb-2">
                  <span class="font-weight-medium">{{ $t('L_bank_account_holder') }}</span>
                </div>
                <div>
                  <span class="font-weight-regular grey-ada-text"
                    >{{ selpackage.pacSignature }}
                  </span>
                </div>
              </v-col>
            </v-row>
            <v-row class="mb-4 pt-2">
              <v-col cols="12">
                <div class="mb-2">
                  <span class="font-weight-medium">{{ $t('L_bank_name') }}</span>
                </div>
                <div>
                  <span class="font-weight-regular grey-ada-text">{{ bankName }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <!-- This is for all screen sizes Except mobile -->
          <v-card-text v-if="!$vuetify.display.xs" class="background-light-grey pl-4">
            <v-row class="mt-0 pt-0">
              <v-col cols="12" sm6 class="mt-0 mb-0 ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
                <div>
                  <OnexText
                    class="px-0 mt-0"
                    v-model="initialPremium"
                    readonly
                    hideLabel
                    :label="$t('L_premium_amount')"
                  >
                  </OnexText>
                </div>
              </v-col>
              <v-col cols="12" sm6 class="mt-0 mb-0 ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
                <OnexText
                  class="px-0 mt-0"
                  v-model="selpackage.pacSignature"
                  readonly
                  hideLabel
                  :label="$t('L_bank_account_holder')"
                >
                </OnexText>
              </v-col>
            </v-row>
            <!-- Row Two -->
            <v-row mb-4 class="mt-0 pb-0 pt-0">
              <v-col cols="12" sm6 class="mt-0 mb-0 ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
                <div class="mb-2 px-4">
                  <span class="font-weight-medium">{{ $t('L_account_number') }}</span>
                </div>
                <div class="px-4">
                  <span class="font-weight-regular grey-ada-text"
                    >{{ hideNums(selpackage.pacAcctNum) }}
                  </span>
                </div>
              </v-col>
              <!-- Second part in step one -->
              <v-col cols="12" sm6 class="mt-0 mb-0 ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
                <OnexText v-model="bankName" readonly hideLabel :label="$t('L_bank_name')">
                </OnexText>
              </v-col>
            </v-row>
            <!-- Row Three -->
            <v-row class="mt-0 pb-0 pt-0">
              <v-col cols="12" sm6 class="mt-0 mb-0 ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
                <div class="mb-2 px-4">
                  <span class="font-weight-medium">{{ $t('L_routing_number') }}</span>
                </div>
                <div class="px-4">
                  <span class="font-weight-regular grey-ada-text">{{
                    hideNums(selpackage.pacBankNum)
                  }}</span>
                </div>
              </v-col>
            </v-row>
            <!-- Close rows -->
            <!-- Disclaimer -->
          </v-card-text>
          <v-row class="mb-0 pt-0">
            <v-col cols="12">
              <div class="disclaimer-wrapper">
                <v-row>
                  <v-col cols="12" class="context">
                    <div v-html="$t(disclaimerBody)"></div>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-row class="justify-center">
              <v-col cols="12" mt-3 mb-4 class="text-left text-h4 font-weight-regular">
                {{ $t('L_by_clicking_I_authorize_I_certify_that_I_have_read') }}
              </v-col>
              <v-col class="text-sm-right text-center">
                <v-row class="justify-center">
                  <v-col cols="12" class="d-flex justify-center pb-0">
                    <OnexButton
                      class="text-white mb-3"
                      :width="220"
                      :disabled="!accepted"
                      @click="$emit('open-edelivery')"
                      color="primary"
                    >
                      {{ $t('L_i_authorize') }}
                    </OnexButton>
                  </v-col>
                </v-row>
                <v-row class="justify-center" cols="12">
                  <v-col cols="12" class="d-flex justify-center pt-0">
                    <OnexButton
                      class="mb-3"
                      :width="220"
                      variant="outlined"
                      @click="$emit('display-warning')"
                    >
                      {{ $t('L_cancel') }}
                    </OnexButton>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { filters } from '@/mixins/filters';
import { mapState } from 'pinia';
import { useChildRiderStore } from '@/modules/childrider/store/childrider.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { OnexButton, OnexText } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'ConfirmACHPayment',
  mixins: [filters],
  components: {
    OnexButton,
    OnexText,
  },
  data: () => ({
    accepted: true,
  }),
  computed: {
    ...mapState(usePolicyStore, {
      currentPolicy: 'currentPolicy',
    }),
    ...mapState(useChildRiderStore, {
      bankName: 'bankName',
      selpackage: 'NPPackage',
      selectedPremiumAmount: 'NPSelectedPremiumAmount',
      isCanadaPolicy: 'isCanadaPolicy',
    }),
    getWithDrawDate() {
      const y = this.currentPolicy.paymentInfo.autoDraftPaymentDate;
      const x = parseInt(y, 10);
      if (y && !isNaN(x)) {
        if (x === 1 || x === 21) {
          return `${x}st`;
        } else if (x === 2 || x === 22) {
          return `${x}nd`;
        } else if (x === 3 || x === 23) {
          return `${x}rd`;
        }
        return `${x}th`;
      }
      return '';
    },
    disclaimerTitle() {
      if (this.isCanadaPolicy) {
        return 'L_disclaimer_title_ca';
      }
      return 'L_disclaimer_title_us';
    },
    disclaimerBody() {
      if (this.isCanadaPolicy) {
        return 'L_confirm_payment_disclaimer_body_ca';
      }
      return 'L_confirm_payment_disclaimer_body_us';
    },
    initialPremium() {
      let premiumAmount = this.selectedPremiumAmount;
      const splitVal = premiumAmount.split('.');
      if (splitVal[1] != null) {
        splitVal[1] = `${splitVal[1]}00`.slice(0, 2);
        premiumAmount = `${splitVal[0]}.${splitVal[1]}`;
      } else {
        premiumAmount = `${splitVal[0]}.00`;
      }
      return `$${premiumAmount}`;
    },
  },
  methods: {
    hideNums(value: string | null) {
      if (value && value.length > 5) {
        return (
          value.substring(0, value.length - 4).replace(/\d/g, '*') +
          value.substring(value.length - 4)
        );
      } else if (value?.length === 2) {
        return (
          value.substring(0, value.length - 1).replace(/\d/g, '*') +
          value.substring(value.length - 1)
        );
      }
      return value
        ? value.substring(0, value.length - 2).replace(/\d/g, '*') +
            value.substring(value.length - 2)
        : '';
    },
  },
};

export default defineComponent(componentOptions);
</script>
<style lang="scss" scoped>
.grey-ada-text {
  color: #737171;
}
.disclaimer-wrapper {
  overflow-y: scroll;
  max-height: 263px;
  min-height: 250px;
  border-radius: 2px;
  border: solid 1px #979797;
  padding: 20px;
}
.textCenter {
  text-align: center;
}
</style>
